import React, { useEffect, useState, useRef, useId } from "react";
import { useParams } from "react-router-dom";
import { gql, useLazyQuery, useMutation } from "@apollo/client";
import { Skeleton, Alert, Button, Radio, Space, Modal, Col, Row } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import moment from "moment-jalaali";
import Invoice from "./invoice";
import PaymentDiscount from "./PaymentDiscount";
function PayInvoice(props) {
  const [invoiceDetails, setInvoiceDetails] = useState({});
  const [discountError, setDiscountError] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState("online");
  const [bpmData, setBpmData] = useState(null);
  // const [isPaid, setIsPaid] = useState(false);
  const contentRef = useRef(null);
  const reactToPrintFn = useReactToPrint({
    contentRef,
    pageStyle: `
      @font-face {
        font-family: "IRANSansXFaNum";
        src: url("${window.location.origin}/fonts/woff2/IRANSansXFaNum-Regular.woff2") format("woff2");
      }`,
  });
  const ref02 = useRef();
  const navigate = useNavigate();
  const uniqueId = useId();
  const submitBpmForm = () => setTimeout(() => ref02.current.click(), 5);
  const { invoiceId } = useParams();
  const GETINVOICEDATA = gql`
    query GetInvoce($id: ID!) {
      getInvoice(id: $id) {
        id
        amountRial
        description
        createdAt
        finalAmount
        discountAmount
        user {
          gender
          name
          wallet
        }
        paidAt
        cancelAt
        invoiceType
        startAt
        effectiveStartAt
        expectedEndAt
        package {
          id
          name
          days
        }
      }
    }
  `;

  const APPLYDISCOUNT = gql`
    mutation ApplyDiscount($id: ID!, $code: String!) {
      applyDiscount(id: $id, code: $code) {
        id
        amountRial
        description
        createdAt
        user {
          gender
          name
          wallet
        }
        paidAt
        cancelAt
        invoiceType
        discountAmount
        finalAmount
        startAt
        effectiveStartAt
        expectedEndAt
        package {
          id
          name
          days
        }
      }
    }
  `;

  const STARTPAYMENT = gql`
    mutation StartPayment($startPayInput: StartPayInput!) {
      startPayOnline(startPayInput: $startPayInput) {
        action
        method
        fields {
          name
          value
        }
      }
    }
  `;
  const STARTPAYCOMBINED = gql`
    mutation payCombined($startPayInput: StartPayInput!) {
      payCombined(startPayInput: $startPayInput) {
        isPaid
        startPayReult {
          action
          method
          fields {
            name
            value
          }
        }
      }
    }
  `;
  const STARTPAYWALLET = gql`
    mutation payWalletRial($id: ID!) {
      payWalletRial(id: $id)
    }
  `;
  const [getInvoiceData, invoiceData] = useLazyQuery(GETINVOICEDATA, {
    onError(error) {
      console.log(error.message);
    },
    onCompleted(data) {
      setInvoiceDetails(data?.getInvoice);
    },
  });

  const [getDiscountedInvoiceData, discountedInvoiceData] = useMutation(
    APPLYDISCOUNT,
    {
      onError(error) {
        console.log(error.message);
        setDiscountError(error.message);
      },
      onCompleted(data) {
        setInvoiceDetails(data?.applyDiscount);
        setDiscountError(null);
      },
    }
  );

  const [runGetPaymentData, getPaymentData] = useMutation(STARTPAYMENT, {
    onError(err) {
      console.log("خطا: " + err.message);
      Modal.error({
        title: "مشکلی پیش آمده!",
        content: "لطفا دوباره تلاش کنید!",
        bodyStyle: { direction: "rtl" },
        okText: "باشه",
      });
    },
    onCompleted({ startPayOnline }) {
      setBpmData(startPayOnline);
      submitBpmForm();
    },
  });

  const [runGetCombinedPaymentData, getCombinedPaymentData] = useMutation(
    STARTPAYCOMBINED,
    {
      onError(err) {
        console.log("خطا: " + err.message);
        Modal.error({
          title: "مشکلی پیش آمده!",
          content: "لطفا دوباره تلاش کنید!",
          bodyStyle: { direction: "rtl" },
          okText: "باشه",
        });
      },
      onCompleted({ payCombined }) {
        setBpmData(payCombined?.startPayReult);
        submitBpmForm();
      },
    }
  );

  const [runGetWalletPaymentData, getWalletPaymentData] = useMutation(
    STARTPAYWALLET,
    {
      onError(err) {
        navigate(`/payment-result?invoiceId=${invoiceId}&result=error`);
      },
      onCompleted({ payWalletRial }) {
        // setIsPaid(payWalletRial);
        navigate(`/payment-result?invoiceId=${invoiceId}&result=success`);
      },
    }
  );
  useEffect(() => {
    getInvoiceData({ variables: { id: invoiceId } });
  }, [invoiceId]);

  const { id, user, paidAt, invoiceType, finalAmount } = invoiceDetails;
  const walletBalanceRial = user?.wallet;

  const pay = () => {
    if (paymentMethod === "online") {
      runGetPaymentData({
        variables: { startPayInput: { invoiceId: id, gateway: "BPM" } },
      });
    }
    if (paymentMethod === "combined") {
      runGetCombinedPaymentData({
        variables: { startPayInput: { invoiceId: id, gateway: "BPM" } },
      });
    }
    if (paymentMethod === "wallet") {
      runGetWalletPaymentData({
        variables: { id },
      });
    }
  };
  const applyDiscount = (discountInput) => {
    getDiscountedInvoiceData({
      variables: {
        id,
        code: discountInput?.code,
      },
    });
  };

  if (invoiceData.loading)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );
  if (user?.name)
    return (
      <div className="invoicePage">
        <div style={{ position: "absolute", visibility: "hidden" }}>
          <form action={bpmData?.action} method={bpmData?.method}>
            {bpmData?.fields.map((data) => (
              <input
                type="text"
                defaultValue={data?.value}
                name={data?.name}
                key={uniqueId}
              />
            ))}
            <input type="submit" ref={ref02} />
          </form>
        </div>
        <Row gutter={40}>
          <Col xs={24} md={8}>
            {!paidAt ? (
              <div className="invoicePayment">
                {invoiceDetails?.startAt &&
                  moment(invoiceDetails.startAt).isBefore(
                    moment().startOf("day")
                  ) && (
                    <Alert
                      style={{ marginBottom: 16 }}
                      type="warning"
                      showIcon
                      message="تغییر خودکار تاریخ شروع"
                      description={`تاریخ شروع انتخابی شما (${moment(
                        invoiceDetails.startAt
                      ).format(
                        "jYYYY/jMM/jDD"
                      )}) سپری شده است. جهت حفظ کامل مدت پکیج (${
                        invoiceDetails?.package?.days || ""
                      } روز)، تاریخ شروع مؤثر به امروز (${moment(
                        invoiceDetails.effectiveStartAt
                      ).format("jYYYY/jMM/jDD")}) منتقل شد.`}
                    />
                  )}

                {(invoiceDetails?.effectiveStartAt ||
                  invoiceDetails?.startAt) && (
                  <div
                    style={{
                      background: "#f6f8fa",
                      border: "1px solid #d9d9d9",
                      padding: "10px 14px",
                      borderRadius: 8,
                      marginBottom: 16,
                      fontSize: "12px",
                      lineHeight: "22px",
                    }}
                  >
                    {invoiceDetails.startAt && (
                      <div>
                        تاریخ شروع انتخابی:{" "}
                        <strong>
                          {moment(invoiceDetails.startAt).format(
                            "jYYYY/jMM/jDD"
                          )}
                        </strong>
                      </div>
                    )}
                    <div>
                      تاریخ شروع مؤثر:{" "}
                      <strong style={{ color: "#52c41a" }}>
                        {moment(
                          invoiceDetails.effectiveStartAt ||
                            invoiceDetails.startAt
                        ).format("jYYYY/jMM/jDD")}
                      </strong>
                    </div>
                    {invoiceDetails.expectedEndAt && (
                      <div>
                        تاریخ پایان پیش‌بینی‌شده:{" "}
                        <strong style={{ color: "#1890ff" }}>
                          {moment(invoiceDetails.expectedEndAt).format(
                            "jYYYY/jMM/jDD"
                          )}
                        </strong>
                      </div>
                    )}
                  </div>
                )}

                <div className="invoicePaymentMethod">
                  <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                    انتخاب روش پرداخت
                  </p>
                  <Radio.Group
                    onChange={(e) => setPaymentMethod(e.target.value)}
                    defaultValue={"online"}
                  >
                    <Space direction="vertical">
                      <Radio
                        value={"online"}
                        onChange={() => setPaymentMethod("online")}
                      >
                        پرداخت آنلاین
                      </Radio>
                      {invoiceType !== "RECHARGE_WALLET" && (
                        <>
                          <Radio
                            value={"wallet"}
                            disabled={walletBalanceRial < finalAmount}
                            onChange={() => setPaymentMethod("wallet")}
                          >
                            پرداخت از کیف پول (موجودی:{" "}
                            {walletBalanceRial.toLocaleString()} ریال)
                          </Radio>
                          <Radio
                            value={"combined"}
                            disabled={
                              !(
                                walletBalanceRial > 0 &&
                                walletBalanceRial < finalAmount
                              )
                            }
                            onChange={() => setPaymentMethod("combined")}
                          >
                            پرداخت ترکیبی
                          </Radio>
                        </>
                      )}
                    </Space>
                  </Radio.Group>
                </div>

                {(invoiceType === "PRODUCT" ||
                  invoiceType === "CARD_REQUEST" ||
                  invoiceType === "HOLIDAY") && (
                  <PaymentDiscount
                    loading={discountedInvoiceData.loading}
                    onApplyDiscount={applyDiscount}
                    error={discountError}
                  />
                )}
                <div className="invoicePaymentBtns">
                  <Button type="primary" onClick={pay}>
                    پرداخت
                    {paymentMethod === "online"
                      ? " آنلاین"
                      : paymentMethod === "wallet"
                      ? " کیف پول"
                      : paymentMethod === "combined"
                      ? " ترکیبی"
                      : ""}
                  </Button>

                  <Button
                    type="secondary"
                    icon={<PrinterOutlined />}
                    disabled={paidAt ? false : true}
                    onClick={reactToPrintFn}
                  >
                    چاپ فاکتور
                  </Button>
                </div>
              </div>
            ) : (
              <div className="paidInvoice">
                <Alert
                  type="info"
                  showIcon
                  message={<h4 style={{ fontWeight: "bold" }}>پرداخت شده</h4>}
                  description={` این فاکتور در تاریخ ${moment(paidAt).format(
                    "jYYYY/jMM/jDD"
                  )} تسویه
              شده است.`}
                ></Alert>
                <div className="invoicePaymentBtns">
                  <Button type="primary" href="/transactions">
                    تراکنش ها
                  </Button>

                  <Button
                    type="secondary"
                    icon={<PrinterOutlined />}
                    disabled={paidAt ? false : true}
                    onClick={reactToPrintFn}
                  >
                    چاپ فاکتور
                  </Button>
                </div>
              </div>
            )}
          </Col>
          <Col xs={24} md={16}>
            <Invoice details={invoiceDetails} ref={contentRef} />
          </Col>
        </Row>
      </div>
    );
  else
    return (
      <div>
        <Alert
          message="لطفا ابتدا پروفایل خود را تکمیل کنید."
          type="warning"
          banner
          action={
            <Button size="small" danger>
              <Link to="/profile"> تکمیل پروفایل</Link>
            </Button>
          }
        />
      </div>
    );
}

export default PayInvoice;
